import React from 'react';
import gridActive from '../images/grid-active.svg';
import gridInactive from '../images/grid-inactive.svg';
import listActive from '../images/list-active.svg';
import listInactive from '../images/list-inactive.svg';

const ViewToggle = ({ viewMode, onChange }) => (
  <div className='view-toggle' aria-label='รูปแบบการแสดงผล'>
    <button
      type='button'
      className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
      onClick={() => onChange('grid')}
      aria-label='แสดงแบบตาราง'
      aria-pressed={viewMode === 'grid'}
    >
      <img className='toggle-icon' src={viewMode === 'grid' ? gridActive : gridInactive} alt='' />
    </button>
    <button
      type='button'
      className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
      onClick={() => onChange('list')}
      aria-label='แสดงแบบรายการ'
      aria-pressed={viewMode === 'list'}
    >
      <img className='toggle-icon' src={viewMode === 'list' ? listActive : listInactive} alt='' />
    </button>
  </div>
);

export default ViewToggle;
